import React, {useEffect, useContext} from 'react';
import {TopBar} from '../common/TopBar';
import {Sidebar} from '../common/Sidebar';
import ChartApp from './ChartApp';
import { AppContext } from '../../context/app/appContext';

export const ReportsPage = (props) => {
    const appContext = useContext(AppContext)

    useEffect(() => {
        if (!appContext.teams.length) {
            (async function loadTeams() {
                await appContext.loadTeams();
            })();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!appContext.employees.length) {
            (async function loadEmployees() {
                await appContext.setEmployees();
            })();
        }
        // eslint-disable-next-line
    }, []);

  return (
      <div id="app">
            <div id="content" style={{display: 'flex', height: '100vh'}}>
                <span style={{width: '10vw', height: '100vh'}}>
                    <Sidebar />
                </span>
                <span style={{width: '90vw', height: '100vh'}}>
                    <div style={{width: '100%', height: '10vh'}}>
                        <TopBar />
                    </div>
                    <div style={{width: '90vw', height: '91.5vh', overflowY: 'scroll', overflowX: 'visible'}}>
                      <ChartApp />
                    </div>
                </span>
            </div>
        </div>
  );
};
